'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var Tooltip_web = require('../../atoms/Tooltip/Tooltip.web.cjs');

/**
 * A badge to display the quality of a product using SVG components
 *
 * @scope Web
 */ const QualityBadge = ({ type, tooltipContent, ...rest })=>{
    const theme = react.useTheme();
    if (!type) return null;
    const defaultTooltipContent = `Emerson Quality Program: ${type} tier recognition for exceptional product quality and standards.`;
    return /*#__PURE__*/ jsxRuntime.jsx(Tooltip_web.Tooltip, {
        tooltipContent: tooltipContent || defaultTooltipContent,
        intention: "neutral",
        alignment: "top",
        ...rest,
        children: /*#__PURE__*/ jsxRuntime.jsxs("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: theme.ds5.brand.emerson[type],
            xmlns: "http://www.w3.org/2000/svg",
            role: "img",
            "aria-label": `${type} quality badge`,
            ...rest,
            children: [
                /*#__PURE__*/ jsxRuntime.jsx("path", {
                    d: "M11.4007 0.448606C11.756 0.182665 12.244 0.182665 12.5993 0.448606L13.8303 1.37015C14.0652 1.54596 14.3654 1.60978 14.6515 1.54469L16.1509 1.20353C16.5836 1.10508 17.0295 1.30358 17.2458 1.69102L17.9956 3.03362C18.1387 3.28975 18.387 3.47015 18.6748 3.52704L20.1834 3.82526C20.6187 3.91132 20.9453 4.274 20.9853 4.71596L21.1242 6.24745C21.1507 6.53962 21.3042 6.80542 21.544 6.97445L22.8008 7.86048C23.1635 8.11617 23.3144 8.58031 23.1712 9.00037L22.6752 10.4559C22.5806 10.7336 22.6126 11.0389 22.7629 11.2908L23.5508 12.6115C23.7781 12.9926 23.7271 13.4779 23.4255 13.8034L22.3803 14.9314C22.1809 15.1466 22.0861 15.4385 22.1209 15.7298L22.3034 17.2567C22.3561 17.6973 22.1121 18.12 21.7042 18.2947L20.2906 18.9C20.0209 19.0155 19.8155 19.2436 19.7288 19.5239L19.2746 20.993C19.1435 21.417 18.7486 21.7039 18.3049 21.6975L16.7673 21.6756C16.474 21.6714 16.1936 21.7962 16.0004 22.017L14.9878 23.1744C14.6956 23.5084 14.2183 23.6098 13.8155 23.4236L12.4197 22.7781C12.1535 22.655 11.8465 22.655 11.5803 22.7781L10.1845 23.4236C9.78172 23.6098 9.30436 23.5084 9.01215 23.1744L7.9996 22.017C7.80643 21.7962 7.52604 21.6714 7.2327 21.6756L5.69508 21.6975C5.25136 21.7039 4.85653 21.417 4.72544 20.993L4.27117 19.5239C4.1845 19.2436 3.97913 19.0155 3.70945 18.9L2.29584 18.2947C1.8879 18.12 1.64388 17.6973 1.69656 17.2567L1.87912 15.7298C1.91395 15.4385 1.8191 15.1466 1.61971 14.9314L0.574528 13.8034C0.272909 13.4779 0.221896 12.9926 0.449245 12.6115L1.23706 11.2908C1.38736 11.0389 1.41944 10.7336 1.32481 10.4559L0.828786 9.00037C0.685642 8.58031 0.836452 8.11617 1.19916 7.86048L2.45602 6.97445C2.6958 6.80542 2.84926 6.53962 2.87576 6.24745L3.01465 4.71596C3.05473 4.274 3.38129 3.91132 3.81663 3.82526L5.32522 3.52704C5.61302 3.47015 5.86132 3.28975 6.00436 3.03362L6.75416 1.69102C6.97054 1.30358 7.41638 1.10508 7.84909 1.20353L9.34854 1.54469C9.6346 1.60978 9.93481 1.54596 10.1697 1.37015L11.4007 0.448606Z"
                }),
                /*#__PURE__*/ jsxRuntime.jsx("path", {
                    d: "M6.37514 16.2235C5.2225 12.6893 6.05912 5.69863 18.6267 6.01007C14.4513 6.18562 6.1553 8.47409 6.37514 16.2235Z",
                    fill: "white"
                }),
                /*#__PURE__*/ jsxRuntime.jsx("path", {
                    d: "M7.125 17.1927C16.1751 17.8156 18.3613 10.4143 18.3232 6.63574C15.6301 14.4401 10.728 16.2843 8.61351 16.2309C8.57687 13.0432 12.3386 9.83413 14.224 8.62805C8.67305 10.2219 7.17843 15.0019 7.125 17.1927Z",
                    fill: "white"
                })
            ]
        })
    });
};

exports.QualityBadge = QualityBadge;
//# sourceMappingURL=QualityBadge.web.cjs.map
